export const energeticasProducts = [
  {
    id: 1,
    name: 'Score Gorilla 473 ml',
    image: 'https://public.readdy.ai/ai/img_res/ff711517-35b0-4114-afd0-c9f9f5e216b6.png',
    unitsPerPack: 24,
    packagingType: 'Bandeja',
    unitPrice: 830,
    packPrice: 19920,
    palletPrice: 820
  },
  {
    id: 2,
    name: 'Score Original 473 ml',
    image: 'https://public.readdy.ai/ai/img_res/87b033fe-3376-4a77-9b9a-35dab7591f3f.png',
    unitsPerPack: 24,
    packagingType: 'Bandeja',
    unitPrice: 830,
    packPrice: 19920,
    palletPrice: 820
  },
  {
    id: 3,
    name: 'Score Gorilla Zero 473 ml',
    image: 'https://public.readdy.ai/ai/img_res/bfa4e811-10a8-404b-9f23-3c24d1a56f20.png',
    unitsPerPack: 24,
    packagingType: 'Bandeja',
    unitPrice: 830,
    packPrice: 19920,
    palletPrice: 820
  },
  {
    id: 4,
    name: 'Score Fruit Punch 473 ml',
    image: 'https://public.readdy.ai/ai/img_res/bec46afd-4e5e-49c1-a072-d73e8703f98c.png',
    unitsPerPack: 24,
    packagingType: 'Bandeja',
    unitPrice: 830,
    packPrice: 19920,
    palletPrice: 820
  },
  {
    id: 5,
    name: 'Score Bubble Gum 473 ml',
    image: 'https://public.readdy.ai/ai/img_res/fffc3155-d83e-443d-b9a1-24be404f63d9.png',
    unitsPerPack: 24,
    packagingType: 'Bandeja',
    unitPrice: 830,
    packPrice: 19920,
    palletPrice: 820
  },
  {
    id: 6,
    name: 'Score Radical White 473 ml',
    image: 'https://public.readdy.ai/ai/img_res/4bc45c83-77b6-4fa0-a72a-c57d9e39769d.png',
    unitsPerPack: 24,
    packagingType: 'Bandeja',
    unitPrice: 830,
    packPrice: 19920,
    palletPrice: 820
  },
  {
    id: 7,
    name: 'Score Mojito 473 ml',
    image: 'https://public.readdy.ai/ai/img_res/e7bdf7f8-aded-4170-adc5-a0300b184fcb.png',
    unitsPerPack: 24,
    packagingType: 'Bandeja',
    unitPrice: 830,
    packPrice: 19920,
    palletPrice: 820
  },
  {
    id: 8,
    name: 'Score Mango 500 ml',
    image: 'https://public.readdy.ai/ai/img_res/debaa043-1aea-44ba-9a3c-4302b8039b49.png',
    unitsPerPack: 24,
    packagingType: 'Bandeja',
    unitPrice: 830,
    packPrice: 19920,
    palletPrice: 820
  },
  {
    id: 9,
    name: 'Red Bull 250 ml',
    image: 'https://public.readdy.ai/ai/img_res/ed80982a-d6e2-4600-a17e-4ea33cfd200c.png',
    unitsPerPack: 24,
    packagingType: 'Bandeja',
    unitPrice: 1290,
    packPrice: 26160,
    palletPrice: null
  },
  {
    id: 10,
    name: 'Monster 473 ml',
    image: 'https://public.readdy.ai/ai/img_res/d393baf59daa4a9fe62b90e7023b7551.jpg',
    unitsPerPack: 6,
    packagingType: 'Bandeja',
    unitPrice: 1390,
    packPrice: 7620,
    palletPrice: null
  }
];
